import React, { useEffect, useState, useMemo } from "react";
import {
  Button,
  Input,
  Modal,
  Form,
  Tooltip,
  Spin,
  message,
  Col,
  Row,
  Space,
  Badge,
} from "antd";
import LocationPicker from "../../Reusablecomponents/LocationPicker/LocationPicker";
import { ReactComponent as Alert } from "../../assets/images/alert1.svg";
import { ReactComponent as Filter } from "../../assets/images/filter-svgrepo-com (1).svg";
import { EyeOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { ButtonFilled } from "../../Reusablecomponents/UIButtons"; // Custom Button component
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import { useLocation, useNavigate } from "react-router-dom";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import edit from "../../assets/images/Editicon.svg";
import { ReactComponent as Impersonatethree } from "../../assets/livetracking/impersonateOne.svg";
import { useDispatch } from "react-redux";
import {
  setAllEntityList,
  setConsigneeList,
  setConsignerList,
  setCountryList,
  setDriverList,
  setDriverWithVehicle,
  setKpiNameList,
  setLatLongList,
  setRespientList,
  setRoleList,
  setSmsTemplate,
  setSupllierList,
  setTransporterList,
  setUserInfo,
  setUserList,
  setUserPermissionList,
  setVehicleList,
  setVehicleType,
  setMyPermissionList,
  ssetOfficeList,
} from "../../Redux/AuthSlice";
import { jwtDecode } from "jwt-decode";

const Customstyle = styled.div`
  .Impersonatetwo_icon > path {
    fill: #5f6d8c !important;
    transition: color 0.3s ease;
  }

  .Impersonatetwo_icon > path:hover {
    fill: #066d08 !important;
  }

  .create_btn_mastercom:hover {
    background-color: #066d08 !important;
    color: #fff !important;
  }
  @media (max-width: 480px) {
    .category-count-search {
      flex-direction: column;
      gap: 20px;
    }
    .btnn {
      flex-direction: column;
      align-self: flex-end;
    }
    .Create_btn {
      align-self: flex-end;
    }
  }
  .category-count-search {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .total {
    color: #5f6d8c;
    font-size: 16px;
    font-weight: 400;
    align-self: flex-start;
  }
  .Totaldiv {
  }
  .btnn {
    display: flex;
    align-items: center;
  }
  .inactive-status {
    color: #f20000;
  }
  .active-status {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .status-indicator {
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #78e38a;
    border: 1px solid #2c963d;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .status-indicator::before {
    content: "";
    width: 4px;
    height: 4px;
    background-color: #c2f7cb;
    border-radius: 50%;
  }
  .ant-form-item-has-error .ant-input {
    color: #333 !important; /* Example: Dark gray */
  }
`;
const StyledInput = styled(Input)`
  width: 312px !important; // Set the desired width
  height: 39px;
  border-radius: 24px;
`;

const MasterCompany = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const [hoveredRow, setHoveredRow] = useState(null);
  const [masterCompanyData, setMasterComplanyData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [popupMessage, setPopupMessage] = useState(null); // To store the message
  const [isPopupVisible, setIsPopupVisible] = useState(false); // To control popup visibility
  const [filterValues, setFilterValues] = useState({
    companycode: "",
    companyname: "",
    email: "",
    contact: "",
  });
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [isLocationPickerVisible, setIsLocationPickerVisible] = useState(false);
  const [editValue, seteditValue] = useState(false);
  const [impersonateModalVisible, setImpersonateModalVisible] = useState(false);
  const [mcid, setMcid] = useState(null);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const compCreateAllowed = useMemo(
    () => hasPermission("MASTERCOMP", "C"),
    [reduxPermissions],
  );
  const compUpdateAllowed = useMemo(
    () => hasPermission("MASTERCOMP", "U"),
    [reduxPermissions],
  );
  const compImpAllowed = useMemo(
    () => hasPermission("MASTERCOMP", "IMP"),
    [reduxPermissions],
  );
  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

   useEffect(() => {
    if(userInfo?.UID !== 2){
      navigate("/Home");
    }
  }, [userInfo?.UID]);

  const [expandedRows, setExpandedRows] = useState({});

  const toggleViewMore = (key) => {
    setExpandedRows((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const [customFields, setCustomFields] = useState([]);
  const getFieldType = (type) => {
    const typeMap = {
      1: "selectwithvalue", // Dropdown
      2: "text", // Textbox
      3: "checkbox", // Checkbox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };
  const dynamicCustomColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) return [];

    return customFields.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME, // ← match raw field name
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);
  const fetchConsigneeList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 3,
    });
    dispatch(setConsigneeList(data));
  };

  const fetchTransporterList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 2,
    });
    dispatch(setTransporterList(data));
  };
  const fetchConsignerList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getName", {
      mcId: MCID,
      entType: 1,
    });
    dispatch(setConsignerList(data));
  };
  const fetchAllVehicleList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getAllRegNo", {
      mcId: MCID,
    });
    dispatch(setVehicleList(data));
  };
  const fetchRoleList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getRole", {
      mcId: MCID,
    });
    dispatch(setRoleList(data));
  };
  const fetchOfficeList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getoffice", {
      mcId: MCID,
    });
    dispatch(ssetOfficeList(data));
  };
  const fetchVehicleType = async (MCID) => {
    const { data } = await CALL_API("GET", "common/getVehicleType");
    dispatch(setVehicleType(data));
  };
  const fetchCountryList = async () => {
    const { data } = await CALL_API("GET", "common/getAllCountries");
    dispatch(setCountryList(data));
  };
  const fetchLatLongList = async () => {
    const { data } = await CALL_API("GET", `common/getLatLongLocation`);
    dispatch(setLatLongList(data));
  };
  const fetchUserLiat = async () => {
    const { data } = await CALL_API("GET", `user/getAll`);
    dispatch(setUserList(data));
  };
  const fetchSMSTemplateOptions = async () => {
    const { data } = await CALL_API("GET", "mastertable/msgtemplate", {});
    dispatch(setSmsTemplate(data));
  };
  const fetchDriverList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getDriver", {
      mcId: MCID,
    });
    dispatch(setDriverList(data));
  };
  const fetchKpiNameList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getKPIName", {
      mcId: MCID,
    });
    dispatch(setKpiNameList(data));
  };
  const fetchAllEntityList = async (MCID) => {
    const { data } = await CALL_API("GET", `common/getEntity?mcId=${MCID}`);
    dispatch(setAllEntityList(data));
  };
  const fetchRespientList = async (MCID) => {
    const { data } = await CALL_API("GET", `common/getRecpList?mcId=${MCID}`);
    dispatch(setRespientList(data));
  };
  const fetchDriverWithVehicle = async (MCID) => {
    const { data } = await CALL_API(
      "GET",
      `common/getVehicleWithDriver?mcid=${MCID}`,
    );
    dispatch(setDriverWithVehicle(data?.recordsets[0]));
  };
  const fetchUserPermissionList = async (MCID, UID) => {
    const { data } = await CALL_API(
      "POST",
      "role/getCurrentUserOrAdminPermission",
      {
        MCID: MCID,
        UID: UID,
      },
    );
    dispatch(setUserPermissionList(data));
  };
  const fetchSupllierList = async (MCID) => {
    const { data } = await CALL_API("POST", "common/getSupplier", {
      mcId: MCID,
    });
    dispatch(setSupllierList(data));
  };

  const fetchMyPermissions = async () => {
    try {
      const { data } = await CALL_API("GET", `role/getMyPermissions`);

      // Normalize response (flatten nested arrays if present)
      let items = data ?? [];
      if (
        Array.isArray(items) &&
        items.length === 1 &&
        Array.isArray(items[0])
      ) {
        items = items[0];
      }
      if (Array.isArray(items) && items.some(Array.isArray))
        items = items.flat(1);

      const perms = (items || []).reduce((acc, item) => {
        const code = (item?.SECCODE || "").toUpperCase();
        const action = (item?.ACTION || "").toUpperCase();
        if (!code) return acc;
        if (!acc[code]) acc[code] = new Set();
        acc[code].add(action);
        return acc;
      }, {});

      const permObj = Object.keys(perms).reduce((acc, k) => {
        acc[k] = Array.from(perms[k]);
        return acc;
      }, {});

      dispatch(setMyPermissionList(permObj));
    } catch (err) {
      console.error("Error loading permissions:", err);
      dispatch(setMyPermissionList({}));
    }
  };

  const handleImpersonate = async () => {
    try {
      const payload = {
        UID: userInfo?.UID,
        MCID: mcid,
      };

      const { data } = await CALL_API(
        "POST",
        "/mastercompany/impersonate",
        payload,
      );
      if (data.Token) {
        setMcid(null);
        window.localStorage.removeItem("token");
        window.localStorage.setItem("token", data.Token);
        sessionStorage.removeItem("tokenTimestamp");
        sessionStorage.setItem(
          "tokenTimestamp",
          new Date().getTime().toString(),
        );
        const tokenDetails = jwtDecode(data.Token);
        dispatch(
          setUserInfo({
            email: tokenDetails?.EMAIL,
            firstName: tokenDetails?.FIRSTNM,
            lastName: tokenDetails?.LASTNM,
            MCID: tokenDetails?.MCID,
            UID: tokenDetails?.UID,
            WialonToken: tokenDetails?.WialonToken,
            NexusCompId: tokenDetails?.NexusCompId,
            SYSADM: tokenDetails?.SYSADM,
          }),
        );
        fetchConsigneeList(tokenDetails?.MCID);
        fetchTransporterList(tokenDetails?.MCID);
        fetchConsignerList(tokenDetails?.MCID);
        fetchAllVehicleList(tokenDetails?.MCID);
        fetchSupllierList(tokenDetails?.MCID);
        fetchRoleList(tokenDetails?.MCID);
        fetchOfficeList(tokenDetails?.MCID);
        fetchVehicleType();
        fetchCountryList();
        fetchLatLongList();
        fetchUserLiat();
        fetchSMSTemplateOptions();
        fetchDriverList(tokenDetails?.MCID);
        fetchKpiNameList(tokenDetails?.MCID);
        fetchAllEntityList(tokenDetails?.MCID);
        fetchRespientList(tokenDetails?.MCID);
        fetchDriverWithVehicle(tokenDetails?.MCID);
        fetchUserPermissionList(tokenDetails?.MCID, tokenDetails?.UID);
        fetchMyPermissions();
        navigate("/Home");

        message.success("Impersonation successful!");
      } else {
        message.error("No token returned from impersonation API!");
      }
    } catch (error) {
      message.error("Impersonation failed!");
      console.error("Impersonate error:", error);
    }
  };

  const showImpersonateConfirm = () => {
    setImpersonateModalVisible(true);
  };
  const handleImpersonateYes = async () => {
    setImpersonateModalVisible(false);
    await handleImpersonate();
  };
  const handleImpersonateNo = () => {
    setImpersonateModalVisible(false);
  };

  const columns = [
    {
      title: "Company Code",
      dataIndex: "CODE",
      key: "CODE",
    },
    {
      title: "Company Name",
      dataIndex: "COMPNAME",
      key: "COMPNAME",
    },
    {
      title: "Email",
      dataIndex: "EMAIL",
      key: "EMAIL",
    },
    {
      title: "Address",
      dataIndex: "ADDRESS",
      key: "ADDRESS",
      render: (text, record) => {
        const isExpanded = expandedRows[record.key];
        const truncatedAddress =
          text?.length > 50 && !isExpanded
            ? `${text.substring(0, 50)}...`
            : text;

        return (
          <div>
            <p style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {truncatedAddress}
            </p>
            {text?.length > 50 && (
              <span
                style={{ color: "#2C963D", cursor: "pointer" }}
                onClick={() => toggleViewMore(record.key)}
              >
                {isExpanded ? "View Less" : "View More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Phone",
      dataIndex: "CONTACT",
      key: "CONTACT",
    },
    {
      title: "Status",
      dataIndex: "STATUS",
      key: "STATUS",
      width: "15%",
      render: (text) =>
        text === 1 ? (
          <>
            <span className="active-status">
              <span className="status-indicator"></span>
              Active
            </span>
          </>
        ) : (
          <span className="inactive-status">Inactive</span>
        ),
    },
    {
      title: "",
      width: 150,
      key: "actions",
      render: (_, record) => {
        return (
          <>
            <Customstyle>
              {hoveredRow === record.key ? (
                <>
                  <Tooltip>
                    <img
                      style={{
                        cursor: "pointer",
                      }}
                      src={edit}
                      onClick={(e) => {
                        e.stopPropagation();
                        seteditValue(true);
                        setFormData({
                          code: record?.CODE,
                          name: record?.COMPNAME,
                          email: record?.EMAIL,
                          phone: record?.CONTACT,
                          emeremail: record?.EMERGENCYEMAIL,
                          emerphone: record?.EMERGENCYPHONE,
                          contperson: record?.CONTACTPERSON,
                          address: record?.ADDRESS,
                          designation: record?.DESIGNATION,
                          CrBy: record?.CRBY,
                          MCID: record?.MCID,
                        });
                        showDrawer(true);
                      }}
                    />
                  </Tooltip>

                  <Impersonatethree
                    style={{
                      color: "#2C963D",
                      fontSize: "18px",
                      marginLeft: "18px",
                      cursor: "pointer",
                    }}
                    className="Impersonatetwo_icon"
                    onClick={(e) => {
                      e.stopPropagation();
                      showImpersonateConfirm();
                      setMcid(record?.MCID);
                    }}
                  />
                </> // Invisible placeholder to keep column width stable
              ) : (
                <div style={{ height: 24, visibility: "hidden" }}>
                  <img src={edit} alt="" style={{ marginRight: 8 }} />
                  <EyeOutlined style={{ fontSize: "18px" }} />
                </div>
              )}
            </Customstyle>
          </>
        );
      },
    },
  ];

  //  setFormData] = useState({
  //   code: "",
  //   name: "",
  //   email: "",
  //   phone: "",
  //   emeremail: "",
  //   emerphone: "",
  //   contperson: "",
  //   address: "",
  //   designation: "",
  // })
  const combinedColumns = useMemo(() => {
    // Find the index of the Status column
    const statusIndex = columns.findIndex((col) => col.key === "STATUS");
    // If not found, fallback to appending at the end
    const insertAt = statusIndex !== -1 ? statusIndex + 1 : columns.length;

    // Build dynamic custom columns
    const dynamicCols = customFields?.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.FIELDNAME,
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field?.CFID] ?? "-",
    }));
    // Insert custom fields after Status column
    const newCols = [...columns];
    newCols?.splice(insertAt, 0, ...(dynamicCols || []));

    return newCols;
  }, [columns, customFields]);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    code: "",
    name: "",
    email: "",
    phone: "",
    emeremail: "",
    emerphone: "",
    contperson: "",
    address: "",
    designation: "",
  });
  const Location = useLocation();
  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);
  const GetAllCustomeData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=Company`,
      );

      SetAllCustomeData(data);
      setCustomDataLoaded(true);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };
  const [locationModal, setLocationModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const locationClick = (name) => {
    setSelectedItem(name);
    setLocationModal(true);
  };

  const handleLocationSelect = (location) => {
    setFormData((prev) => ({
      ...prev,
      [selectedItem]: location.place_name,
      [`${selectedItem}name`]: {
        place_name: location.place_name,
        latitude: location?.center[0],
        longitude: location?.center[1],
      },
    }));

    setLocationModal(false);
  };

  const fetchMasterCompanyData = async () => {
    try {
      setLoading(true);

      const { data } = await CALL_API(
        "GET",
        `mastercompany/getAll?code=${filterValues?.companycode}&compName=${filterValues?.companyname}&email=${filterValues?.email}&contact=${filterValues?.contact}&limit=${pageSize}&page=${currentPage}`,
        {},
      );

      const enrichedData = data?.data?.map((companylist) => {
        const enrichedItem = { ...companylist };

        // Match fields by REFID === MCID
        const matchedFields =
          AllCustomeData?.filter((field) => field.REFID === companylist.MCID) ||
          [];

        matchedFields.forEach((field) => {
          enrichedItem[field.CFID] = field.VALUE;
        });

        return {
          ...enrichedItem,
          key: enrichedItem.MCID, // Ensure unique key
        };
      });

      setMasterComplanyData(enrichedData); // Only one argument allowed
      setTotal(data?.totalRecords || 0);
    } catch (error) {
      console.error("[getTotalConsignments] error -->", error);
    } finally {
      setLoading(false);
    }
  };
  //Custome Field api calling Function

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Company",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  //custome data creat api call functionality
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (MCID) => {
    try {
      const customDataList = customFields
        .map((field) => {
          const fieldName = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
          const value = formData?.[fieldName];
          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: MCID,
              Value: value,
            };
          }
          return null;
        })
        .filter(Boolean);

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      setCreateCustomeData([]);
      console.error("Error creating custom fields:", error);
    }
  };
  const CustomeDataUpdate = async () => {
    setLoading(true);

    try {
      const valueFieldName = formData?.FIELDNAME?.replace(
        /\s+/g,
        "_",
      ).toLowerCase();
      const value = formData?.[valueFieldName];

      const payload = {
        CfId: formData?.CFID,
        RefId: formData?.MCID,
        Value: value,
        DataId: formData?.DATAID,
      };

      const { data } = await CALL_API(
        "PATCH",
        "mastertable/updateCustomData",
        payload,
      );
    } catch (error) {
      console.error("Error updating custom field:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (cfId, refId) => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        {
          RefId: formData?.MCID,
          RefTab: "Company",
          McId: userInfo?.MCID,
        },
      );
      // Optionally refresh data here
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setFormData({
      code: "",
      name: "",
      email: "",
      phone: "",
      emeremail: "",
      emerphone: "",
      contperson: "",
      address: "",
      designation: "",
    });
  };

  const handleFormChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmitFormedit = async (values) => {
    const { data } = await CALL_API("PATCH", "mastercompany/update", {
      Code: values.code,
      CompName: values?.name,
      Status: "1",
      CrBy: formData?.CRBY,
      MCID: formData?.MCID,
      Email: values?.email,
      Contact: values?.phone,
      Address: values?.address,
      ContactPerson: values?.contperson,
      Designation: values?.designation,
      EmergencyEmail: values?.emeremail || "",
      EmergencyPhone: values?.emerphone || "",
    });
    await CustomeDataUpdate(formData?.MCID, values);
    message.success("Company Updated Successfully!");
    form.resetFields();
    seteditValue(false);
    setOpen(false);
  };

  const handleSubmitForm = async (values) => {
    setLoading(true);

    try {
      const payload = {
        Code: values.code,
        CompName: values?.name,
        Status: "0",
        CrBy: userInfo?.UID,
        Email: values?.email,
        Contact: values?.phone,
        Address: values?.address,
        ContactPerson: values?.contperson,
        Designation: values?.designation,
        EmergencyEmail: values?.emeremail || "",
        EmergencyPhone: values?.emerphone || "",
      };

      const { data, ResponseCode, message } = await CALL_API(
        "POST",
        "mastercompany/insert",
        payload,
      );
      await CustomeDataCreate(data?.MCID); // Assuming it accepts company code

      // Handle known validation errors
      if (ResponseCode === 400) {
        const errorMessage = data?.data?.message || message;

        if (errorMessage.includes("already exists")) {
          setPopupMessage(errorMessage);
          setIsPopupVisible(true);
          setLoading(false);
          return; // Exit early
        }

        // Handle other 400 errors
        message.error(
          errorMessage || "Bad request, please check your parameters.",
        );
        setLoading(false);
        return; // Exit early
      }
      message.success("Company Added Successfully!");

      fetchMasterCompanyData();
      GetAllCustomeData();

      setOpen(false);
    } catch (error) {
      console.error("Submit Error:", error);
      message.error("Failed to submit data. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };
  const fieldStyle = {
    width: "259px",
    height: "36px",
    gap: "10px",
    borderRadius: "20px",
    border: "1px solid black",
    opacity: "1",
    padding: "0 10px",
  };
  const textAreaStyle = {
    width: "100%",
    height: "80px",
    borderRadius: "20px",
    border: "1px solid black",
    padding: "10px",
  };

  const AddEditForm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const type = getFieldType(field.FIELDTYPE);
      let options;

      // For dropdowns, parse options from DATASOURCE or OPTIONS
      if (type === "selectwithvalue" && (field.DATASOURCE || field.OPTIONS)) {
        const source = field.DATASOURCE || field.OPTIONS;
        options = source
          .split(",")
          .map((opt) => ({
            label: opt.trim(),
            value: opt.trim(),
          }))
          .filter((opt) => opt.value); // Remove empty options
      }

      return {
        id: field.CFID,
        label: field.FIELDNAME,
        type,
        name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
        value: formData[name],
        onChange: handleChange,
        ...(options ? { options } : {}),
      };
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);

    const staticFields = [
      [
        {
          id: 1,
          label: "Company Code",
          type: "text",
          name: "code",
          placeholder: "Enter Company Code",
          value: formData.code,
          onChange: handleChange,
          style: fieldStyle,
          validationRules: [
            { required: true, message: "Company Code is required" },
          ],
          onKeyDown: (e) => {
            if (!/^[A-Z0-9]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          maxLength: 10,
        },
        {
          id: 2,
          label: "Company Name",
          type: "text",
          name: "name",
          placeholder: "Enter Company Name",
          value: formData.name,
          onChange: handleChange,
          maxLength: 50,
          onKeyDown: (e) => {
            if (!/^[A-Za-z]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          style: fieldStyle,
          validationRules: [
            { required: true, message: "Company Name is required" },
          ],
        },
        {
          id: 3,
          label: "Email",
          type: "email",
          name: "email",
          placeholder: "Enter your email",
          onKeyDown: (e) => {
            if (!/^[A-Za-z0-9@._+-]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          value: formData.email,
          onChange: handleChange,
          maxLength: 60,
          style: fieldStyle,
          validationRules: [
            {
              required: true,
              message: `Email ID is required`,
            },
          ],
        },
        {
          id: 4,
          label: "Phone",
          type: "text",
          name: "phone",
          placeholder: "Enter Phone number",
          onKeyDown: (e) => {
            if (!/^[0-9]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          value: formData.phone,
          onChange: handleChange,
          maxLength: 14,
          style: fieldStyle,
          validationRules: [
            { required: true, message: "Phone number is required" },
          ],
        },
      ],
      [
        {
          id: 5,
          label: "Emergency Email",
          type: "email",
          name: "emeremail",
          placeholder: "Enter Emergency email",
          onKeyDown: (e) => {
            if (!/^[A-Za-z0-9@._+-]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          validationRules: [
            {
              required: false,
              message: `Email ID is required`,
            },
          ],
          maxLength: 60,
          disabled: false,
          style: fieldStyle,
        },
        {
          id: 6,
          label: "Emergency Phone",
          type: "text",
          name: "emerphone",
          placeholder: "Enter Emergency Phone",
          value: formData.emerphone,
          onChange: handleChange,
          maxLength: 14,
          onKeyDown: (e) => {
            if (!/^[0-9]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          style: fieldStyle,
          validationRules: [
            {
              pattern: /^[0-9]+$/,
              message: "Phone number must be a valid number",
            },
          ],
        },
        {
          id: 7,
          label: "Contact Person",
          type: "text",
          name: "contperson",
          maxLength: 30,
          onKeyDown: (e) => {
            if (!/^[A-Za-z\s]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          placeholder: "Enter Contact Person",
          value: formData.contperson,
          onChange: handleChange,
          style: fieldStyle,
        },
        {
          id: 8,
          label: "Designation",
          type: "text",
          name: "designation",
          maxLength: 30,
          onKeyDown: (e) => {
            if (!/^[A-Za-z-]$/.test(e.key)) {
              e.preventDefault();
            }
          },
          placeholder: "Enter Designation",
          value: formData.designation,
          onChange: handleChange,
          style: fieldStyle,
        },
      ],
      [
        {
          id: 9,
          label: "Address",
          type: "location",
          name: "address",
          placeholder: "Enter Address",
          maxLength: 70,
          value: formData.address,
          onChange: handleChange,
          style: textAreaStyle,
        },
        {},
      ],
    ];

    // Combine static fields and custom fields
    const allFields = [
      ...staticFields,
      ...customFieldRows.filter((row) =>
        row.some((field) => Object.keys(field).length > 0),
      ),
    ];

    return {
      totalpages: 1,
      pages: [
        {
          modalView: false,
          colSpan: [6],
          ...customFieldRows.map((row) => row.map(() => 6)),
          fields: allFields,
        },
      ],
    };
  }, [customFields, formData]);
  useEffect(() => {
    loadCustomFields();
    GetAllCustomeData();
  }, []);
  useEffect(() => {
    if (customDataLoaded) {
      fetchMasterCompanyData();
    }
  }, [customDataLoaded, currentPage, pageSize, filterValues]);

  return (
    <Customstyle>
      <Modal
        open={impersonateModalVisible}
        footer={null}
        closable={true}
        onCancel={handleImpersonateNo}
        centered
        bodyStyle={{
          textAlign: "center",
          padding: "32px 24px 24px 24px",
        }}
      >
        <h2 style={{ marginBottom: 0 }}>Are you sure,</h2>
        <div
          style={{
            margin: "12px 0 24px 0",
            color: "#222",
            fontSize: 16,
          }}
        >
          Are you sure, you want to Impersonate this Company Admin?
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 16,
          }}
        >
          {" "}
          <button
            style={{
              background: "#F5F5F5",
              color: "#6B6B6B",
              border: "none",
              borderRadius: 20,
              width: 100,
              height: 40,
              fontWeight: 400,
              fontSize: 16,
              cursor: "pointer",
            }}
            onClick={handleImpersonateNo}
          >
            Cancel
          </button>
          <button
            style={{
              background: "#2C963D",
              color: "#fff",
              border: "none",
              borderRadius: 20,
              width: 100,
              height: 40,
              fontWeight: 600,
              fontSize: 16,
              cursor: "pointer",
            }}
            onClick={handleImpersonateYes}
          >
            Confirm{" "}
          </button>
        </div>
      </Modal>
      <div className="Totaldiv">
        <div className="category-count-search">
          <div className="total">{total} Master Companies</div>
          <div className="btnn">
            <div>
              <Button
                className="rounded-circle border"
                onClick={() => setFilterModalOpen(true)}
              >
                <Space size="middle">
                  <Badge size="small" count={filterCount}>
                    <Filter />{" "}
                  </Badge>
                </Space>
              </Button>
            </div>
            <div className="Create_btn">
              <Tooltip>
                <ButtonFilled
                  type="primary"
                  className="create_btn_mastercom"
                  onClick={showDrawer}
                >
                  + Create
                </ButtonFilled>
              </Tooltip>
            </div>
          </div>
        </div>
        <Spin spinning={loading}>
          {masterCompanyData?.length > 0 && (
            <StyledTable
              dataSource={masterCompanyData}
              columns={combinedColumns}
              pagination={false}
              onRow={(record) => ({
                onMouseEnter: () => setHoveredRow(record.key),
                onMouseLeave: () => setHoveredRow(null),
                onClick: () => {
                  navigate(`/Viewcompany/${record.key}`, {
                    state: { ...record },
                  });
                },
              })}
            />
          )}
          <ReusablePagination
            pageSize={pageSize}
            handlePageSizeChange={handlePageSizeChange}
            currentPage={currentPage}
            total={total}
            handlePageChange={handlePageChange}
          />
        </Spin>
        <ReusableDrawer
          title={editValue ? "Modifying User" : "Creating Master Company"}
          open={open}
          setOpen={setOpen}
          onOk={editValue ? handleSubmitFormedit : handleSubmitForm}
          onCancel={handleCancel}
          footer={[
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <Button
                key="cancel"
                className="cancel-btn"
                onClick={handleCancel}
                style={{
                  borderRadius: "26px",
                  backgroundColor: "#E8FFEC",
                  color: "#2C963D",
                  borderColor: "#E8FFEC",
                  width: "118px",
                  height: "38px",
                }}
              >
                Cancel
              </Button>
              <ButtonFilled
                loading={loading}
                key="create"
                type="primary"
                onClick={() => form.submit()}
              >
                {editValue ? "update" : "Create"}
              </ButtonFilled>
            </div>,
          ]}
          children={
            <GridBuilder
              formStructureJson={AddEditForm}
              handleChange={handleChange}
              formSubmit={editValue ? handleSubmitFormedit : handleSubmitForm}
              initialValues={formData}
              form={form}
              locationClick={locationClick}
              handleSelectChange={handleSelectChange}
            />
          }
        />
      </div>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              setFilterValues({
                companycode: "",
                companyname: "",
                email: "",
                contact: "",
              });
              filterform?.setFieldsValue({
                companycode: "",
                companyname: "",
                email: "",
                contact: "",
              });
              setFilterCount(0);
              setFilterModalOpen(false);
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            const count = Object.values(allvalues).filter(
              (val) =>
                val !== undefined && val !== null && String(val).trim() !== "",
            ).length;

            setFilterCount(count);
            setFilterValues(allvalues);
          }}
          initialValues={filterValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Company Code" name="companycode">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Company Name" name="companyname">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Contact No" name="contact">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Email" name="email">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Alert />
            <span>Information</span>
          </div>
        }
        visible={isPopupVisible}
        onOk={() => setIsPopupVisible(false)} // Close the popup when "OK" is clicked
        onCancel={() => setIsPopupVisible(false)} // Allow closing with the "X" button
        footer={[
          <ButtonFilled key="ok" onClick={() => setIsPopupVisible(false)}>
            OK
          </ButtonFilled>,
        ]}
      >
        <p style={{ fontSize: "15px" }}>{popupMessage}</p>
      </Modal>
      <LocationPicker
        visible={locationModal}
        onClose={() => setLocationModal(false)}
        onSelect={handleLocationSelect}
      />
    </Customstyle>
  );
};

export default MasterCompany;
